import { code } from 'currency-codes'

const ISO3166_1_ALPHA_2_TO_PRIMARY_LANGUAGE = Object.freeze({
  AC: 'en',
  AD: 'ca',
  AE: 'ar',
  AF: 'fa',
  AG: 'en',
  AI: 'en',
  AL: 'sq',
  AM: 'hy',
  AO: 'pt',
  AQ: 'und',
  AR: 'es',
  AS: 'sm',
  AT: 'de',
  AU: 'en',
  AW: 'nl',
  AX: 'sv',
  AZ: 'az',
  BA: 'bs',
  BB: 'en',
  BD: 'bn',
  BE: 'nl',
  BF: 'fr',
  BG: 'bg',
  BH: 'ar',
  BI: 'rn',
  BJ: 'fr',
  BL: 'fr',
  BM: 'en',
  BN: 'ms',
  BO: 'es',
  BQ: 'nl',
  BR: 'pt',
  BS: 'en',
  BT: 'dz',
  BV: 'und',
  BW: 'en',
  BY: 'be',
  BZ: 'en',
  CA: 'en',
  CC: 'ms-Arab',
  CD: 'fr',
  CF: 'fr',
  CG: 'fr',
  CH: 'de',
  CI: 'fr',
  CK: 'en',
  CL: 'es',
  CM: 'fr',
  CN: 'zh',
  CO: 'es',
  CP: 'und',
  CQ: 'en',
  CR: 'es',
  CU: 'es',
  CV: 'pt',
  CW: 'nl',
  CX: 'en',
  CY: 'el',
  CZ: 'cs',
  DE: 'de',
  DG: 'en',
  DJ: 'ar',
  DK: 'da',
  DM: 'en',
  DO: 'es',
  DZ: 'ar',
  EA: 'es',
  EC: 'es',
  EE: 'et',
  EG: 'ar',
  EH: 'ar',
  ER: 'en',
  ES: 'es',
  ET: 'am',
  FI: 'fi',
  FJ: 'en',
  FK: 'en',
  FM: 'en',
  FO: 'fo',
  FR: 'fr',
  GA: 'fr',
  GB: 'en',
  GD: 'en',
  GE: 'ka',
  GF: 'fr',
  GG: 'en',
  GH: 'en',
  GI: 'en',
  GL: 'kl',
  GM: 'en',
  GN: 'fr',
  GP: 'fr',
  GQ: 'es',
  GR: 'el',
  GS: 'und',
  GT: 'es',
  GU: 'ch',
  GW: 'pt',
  GY: 'en',
  HK: 'zh-Hant',
  HM: 'und',
  HN: 'es',
  HR: 'hr',
  HT: 'ht',
  HU: 'hu',
  IC: 'es',
  ID: 'id',
  IE: 'en',
  IL: 'he',
  IM: 'en',
  IN: 'hi',
  IO: 'en',
  IQ: 'ar',
  IR: 'fa',
  IS: 'is',
  IT: 'it',
  JE: 'en',
  JM: 'en',
  JO: 'ar',
  JP: 'ja',
  KE: 'sw',
  KG: 'ky',
  KH: 'km',
  KI: 'en',
  KM: 'ar',
  KN: 'en',
  KP: 'ko',
  KR: 'ko',
  KW: 'ar',
  KY: 'en',
  KZ: 'ru',
  LA: 'lo',
  LB: 'ar',
  LC: 'en',
  LI: 'de',
  LK: 'si',
  LR: 'en',
  LS: 'st',
  LT: 'lt',
  LU: 'fr',
  LV: 'lv',
  LY: 'ar',
  MA: 'ar',
  MC: 'fr',
  MD: 'ro',
  ME: 'sr-Latn',
  MF: 'fr',
  MG: 'mg',
  MH: 'en',
  MK: 'mk',
  ML: 'fr',
  MM: 'my',
  MN: 'mn',
  MO: 'zh-Hant',
  MP: 'en',
  MQ: 'fr',
  MR: 'ar',
  MS: 'en',
  MT: 'mt',
  MU: 'en',
  MV: 'dv',
  MW: 'en',
  MX: 'es',
  MY: 'ms',
  MZ: 'pt',
  NA: 'en',
  NC: 'fr',
  NE: 'fr',
  NF: 'en',
  NG: 'en',
  NI: 'es',
  NL: 'nl',
  NO: 'nb',
  NP: 'ne',
  NR: 'en',
  NU: 'en',
  NZ: 'mi',
  OM: 'ar',
  PA: 'es',
  PE: 'es',
  PF: 'fr',
  PG: 'tpi',
  PH: 'en',
  PK: 'ur',
  PL: 'pl',
  PM: 'fr',
  PN: 'en',
  PR: 'es',
  PS: 'ar',
  PT: 'pt',
  PW: 'pau',
  PY: 'gn',
  QA: 'ar',
  RE: 'fr',
  RO: 'ro',
  RS: 'sr',
  RU: 'ru',
  RW: 'rw',
  SA: 'ar',
  SB: 'en',
  SC: 'fr',
  SD: 'ar',
  SE: 'sv',
  SG: 'en',
  SH: 'en',
  SI: 'sl',
  SJ: 'nb',
  SK: 'sk',
  SL: 'en',
  SM: 'it',
  SN: 'fr',
  SO: 'so',
  SR: 'nl',
  SS: 'en',
  ST: 'pt',
  SV: 'es',
  SX: 'en',
  SY: 'ar',
  SZ: 'en',
  TA: 'en',
  TC: 'en',
  TD: 'fr',
  TF: 'fr',
  TG: 'fr',
  TH: 'th',
  TJ: 'tg',
  TK: 'en',
  TL: 'pt',
  TM: 'tk',
  TN: 'ar',
  TO: 'to',
  TR: 'tr',
  TT: 'en',
  TV: 'tvl',
  TW: 'zh-Hant',
  TZ: 'sw',
  UA: 'uk',
  UG: 'sw',
  UM: 'en',
  US: 'en',
  UY: 'es',
  UZ: 'uz',
  VA: 'it',
  VC: 'en',
  VE: 'es',
  VG: 'en',
  VI: 'en',
  VN: 'vi',
  VU: 'bi',
  WF: 'fr',
  WS: 'sm',
  XK: 'sq',
  YE: 'ar',
  YT: 'fr',
  ZA: 'en',
  ZM: 'en',
  ZW: 'sn',
})

const getLocaleFromISO31661alpha2 = (country: string) => {
  const language =
    ISO3166_1_ALPHA_2_TO_PRIMARY_LANGUAGE[
      country as keyof typeof ISO3166_1_ALPHA_2_TO_PRIMARY_LANGUAGE
    ]
  return language ? `${language}-${country}` : 'en-US'
}

const formatCurrency = (country: string, value: number | string, currency: string | undefined) => {
  const currencyWithFallback = currency || 'EUR'
  const isCurrencyValid = code(currencyWithFallback) !== undefined
  const parsedValue = Number(value)

  if (!isCurrencyValid || isNaN(parsedValue)) {
    return `${currencyWithFallback} ${value.toString().trim()}`
  }

  const locale = getLocaleFromISO31661alpha2(country)

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: (currency || 'EUR').toUpperCase(),
    currencyDisplay: 'code',
    numberingSystem: 'latn',
  } as any).format(Number(value)) // any because ancient webpack complains about numberingSystem, but it has wideline support. TODO: remove when upgrading to vite
}

export const localesUtils = {
  getLocaleFromISO31661alpha2,
  formatCurrency,
}
